import React from 'react';
import { Input } from 'semantic-ui-react';
import clsx from 'clsx';
import { validationClasses } from '@/utils/errors';
import { camelConverter } from '../helper';

const FormInput = ({
  field,
  text,
  onChange,
  disabled,
  autoFocus,
  error,
  icon,
  iconPosition,
  size,
  className,
}) => (
  <Input
    autoComplete="off"
    autoFocus={autoFocus}
    className={clsx(validationClasses(error, 'aridhia-form-input primary aridhia-is-edit-mode'), className)}
    disabled={disabled}
    id={camelConverter(field.name, '_')}
    fluid
    icon={icon}
    iconPosition={iconPosition}
    maxLength={field.validation?.maximum}
    onChange={(e) => onChange(e.target.value)}
    placeholder={field.placeholder}
    size={size}
    type={field.protect ? 'password' : 'custom'}
    value={text || ''}
  />
);

export default FormInput;
